import {
    Box,
    Button,
    Flex,
    IconButton,
    Table,
    TableContainer,
    Tag,
    Tbody,
    Td,
    Text,
    Th,
    Thead,
    Tooltip,
    Tr,
    Image,
    Input,
    useToast,
    Switch,
    Grid,
} from "@chakra-ui/react";
import CommonModal from "components/common/CommonModal/CommonModal";
import CustomDateRangeMobile from "components/common/CustomDateRangeMobile/CustomDateRangeMobile";
import CustomDateRangePicker from "components/common/CustomDateRangePicker/CustomDateRangePicker";
import { Paginationlimit } from "components/common/functions/variable";
import Pagination from "components/common/Pagination/Pagination";
import TableLoader from "components/common/TableLoader/TableLoader";
import React, { useContext, useEffect, useState } from "react";
import { HiOutlineRefresh } from "react-icons/hi";
import { appRequest } from "routes";
// import CreateCategory from "./CreateCategory/CreateCategory";
// import SettingSection from "./SettingSection/SettingSection";
import { EditIcon } from "@chakra-ui/icons";
import { useHasPermission } from "../common/PermissionsFunction/permissiosnFunction";
import debounce from "lodash.debounce";
import SearchBox from "components/layouts/MainWindow/Navbar/SearchBox";
import CreateCategory from "./CreateCategory/CreateCategory";
import FaqTable from "./FaqTable";

export default function CategoriesTable(): JSX.Element {
    const initialDateRange = {
        startDate: new Date(new Date().setDate(new Date().getDate() - 7)),
        endDate: new Date(),
        key: "selection",
    };

    const [dateRange, setDateRange] = useState<any>(initialDateRange);
    const { startDate, endDate } = dateRange;
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [data, setData] = useState<any[]>([]);

    const [searchQuery, setSearchQuery] = useState("");
    const [editingIndex, setEditingIndex] = useState(-1);
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
    const [activePage, setActivePage] = useState("1");
    const [editCategory, setEditCategory] = useState({});
    const [selectedCategoryId, setSelectedCategoryId] = useState<string>("");
    const [switchStates, setSwitchStates] = useState<boolean[]>([]);
    const toast = useToast();

    const getCategories = async (currentP?: number) => {
        try {
            setLoading(true);
            let page = currentP ? currentP : currentPage;
            let limit = Paginationlimit;
            const request: any = {
                limit,
                page,
                ...(searchQuery.trim() && { search: searchQuery.trim() }),
                isActive: true
            };
            // console.log("all categories request", request)
            const response: any = await appRequest("faqCategory", "getAll", request);

            if (response.status === "success") {
                setTotalPages(response?.data?.pages || 0);
                setData(response?.data?.items || []);
                // console.log("response all categories", response)
            }
        } catch (error: any) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleEdit = (item: any) => {
        setEditCategory(item);
        setIsCreateModalOpen(true);
    };

    const updateData = async (editedData: any) => {
        try {
            setLoading(true);
            const payload = {
                id: editedData._id,
                name: editedData?.name,
                description: editedData?.description,
                order: editedData?.order,
                isActive: editedData?.isActive
            };
            // console.log("faqCategory update payload", payload)
            const result: any = await appRequest("faqCategory", "update", payload);
            if (result.status === "success") {
                toast({
                    title: "Success",
                    description: "Category updated successfully!",
                    status: "success",
                    duration: 5000,
                    isClosable: true,
                    position: "top-right",
                });
                getCategories();
                setIsCreateModalOpen(false);
            }
        } catch (error: any) {
            console.error("Error in updateing Category", error);
            toast({
                title: "Error",
                description: "Failed to update category.",
                status: "error",
                duration: 5000,
                isClosable: true,
                position: "top-right",
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getCategories();
    }, [currentPage, searchQuery]);

    const handleSearch = debounce((query: string) => {
        setSearchQuery(query);
        setCurrentPage(1); // Reset to the first page when searching
    }, 300); // Debounce for 300ms

    const handlePageChange = (page: any) => {
        setCurrentPage(page.selected + 1);
    };

    const handleRefreshAllData = () => {
        setSearchQuery("");
        getCategories();
    };

    const handleRowClick = (categoryId: string) => {
        setSelectedCategoryId(categoryId);
        setActivePage("2");
    };

    const canEditCategories = useHasPermission("canEditCategories");

    return (
        <>
            {activePage === "1" && (
                <Box
                    p={5}
                    rounded={"lg"}
                    bg={"white"}
                    shadow={"rgb(0 0 0 / 20%) 0px 0px 11px"}
                >
                    <Flex
                        justify={"space-between"}
                        mb={2}
                        direction={{ base: "column", md: "row" }}
                    >
                        <Text fontWeight={700} fontSize={"xl"} color={"teal.400"} mb={2}>
                            All FAQs Categories
                        </Text>

                        {/* <Flex gap={2} direction={{ base: "column", md: "row" }}>
              <Button
                onClick={() => {
                  setIsCreateModalOpen(true);
                  setEditCategory({});
                }}
                colorScheme="teal"
              >
                ADD
              </Button> */}
                        <Flex gap={2} justify={"end"} direction={{ base: "column", md: "row" }}>
                            <SearchBox onSearch={handleSearch} />

                            <Grid templateColumns="1fr 1fr" gap={2} alignItems={'center'}>
                                <Button
                                    onClick={() => {
                                        setIsCreateModalOpen(true);
                                        setEditCategory({});
                                    }}
                                    colorScheme="teal"
                                    size={{ base: "sm", md: "md" }}
                                >
                                    ADD
                                </Button>
                                <Tooltip label="Refresh" hasArrow>
                                    <IconButton
                                        aria-label="Refresh"
                                        icon={<HiOutlineRefresh />}
                                        colorScheme="teal"
                                        variant="outline"
                                        borderWidth={2}
                                        _hover={{ bg: "teal.100" }}
                                        onClick={handleRefreshAllData}
                                        size={{ base: "sm", md: "md" }}
                                    />
                                </Tooltip>
                            </Grid>
                        </Flex>
                        {/* </Flex> */}
                    </Flex>
                    <TableContainer className="customScrollBar" pb={2}>
                        <Table>
                            <Thead>
                                <Tr>
                                    <Th>Name</Th>
                                    <Th>Description</Th>
                                    <Th>Order</Th>
                                    <Th>isActive</Th>
                                    <Th>Created At</Th>
                                    <Th>Updated At</Th>
                                    <Th>Actions</Th>
                                </Tr>
                            </Thead>
                            <TableLoader
                                noDataText="No Categories Available"
                                show={data?.length}
                                loader={loading}
                            >
                                <Tbody>
                                    {data?.map((category) => (
                                        <Tr
                                            key={category._id}
                                            _hover={{ bg: "gray.100" }}
                                            cursor="pointer"
                                            onClick={() => {
                                                setActivePage("2");
                                                handleRowClick(category._id);
                                            }}
                                        >
                                            <Td>{category.name}</Td>
                                            <Td>{category.description || "N/A"}</Td>
                                            <Td>{category.order}</Td>
                                            <Td>
                                                <Tag
                                                    size="sm"
                                                    colorScheme={category.isActive ? "green" : "red"}
                                                >
                                                    {category.isActive ? "Yes" : "No"}
                                                </Tag>
                                            </Td>
                                            <Td>{new Date(category.createdAt).toLocaleDateString()}</Td>
                                            <Td>{new Date(category.updatedAt).toLocaleDateString()}</Td>
                                            <Td>
                                                {canEditCategories && (
                                                    <IconButton
                                                        aria-label="edit"
                                                        icon={<EditIcon />}
                                                        colorScheme="teal"
                                                        size="sm"
                                                        variant="outline"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleEdit(category);
                                                        }}
                                                    />
                                                )}
                                            </Td>
                                        </Tr>
                                    ))}
                                </Tbody>
                            </TableLoader>
                        </Table>
                    </TableContainer>
                    <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        handlePageChange={handlePageChange}
                    />
                    <CommonModal
                        header="Add/Update Category"
                        width={{ base: "100vw", md: "60vw" }}
                        animate={true}
                        isOpen={isCreateModalOpen}
                        onClose={() => setIsCreateModalOpen(false)}
                        body={
                            <Box>
                                <CreateCategory
                                    getCategories={getCategories}
                                    setIsCreateModalOpen={setIsCreateModalOpen}
                                    editData={editCategory}
                                    onSubmit={updateData}
                                />
                            </Box>
                        }
                    />
                </Box>
            )}
            {activePage === "2" && (
                <FaqTable categoryId={selectedCategoryId} />
            )}
        </>
    );
}
